import { useCallback } from 'react';
import { useLogAnalyticsEvent } from 'shared/src/hooks';

export function useLogClickDeleteMySize() {
  const logAnalyticsEvent = useLogAnalyticsEvent();

  return useCallback(
    ({
      productCategorySno,
      standardCategorySno,
      standardCategoryName,
    }: {
      productCategorySno: number;
      standardCategorySno: number;
      standardCategoryName: string;
    }) => {
      logAnalyticsEvent({
        name: 'CLICK_DELETE_MY_SIZE',
        analytics: {
          PRODUCT_CATEGORY_SNO: productCategorySno,
          STANDARD_CATEGORY_SNO: standardCategorySno,
          STANDARD_CATEGORY_NAME: standardCategoryName,
        },
      });
    },
    [logAnalyticsEvent],
  );
}
